<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters justify="center" align="center">

      <v-col class="pr-2">
        <v-text-field
          ref="input_value"
          v-model="input_value"
          :placeholder="placeholder"
          :error-messages="!checkValid ? error_message: ''"
          solo
          @keyup.enter="submit"
          :autofocus="true"
        ></v-text-field>
      </v-col>
      <v-col 
            cols="auto"
            class="ml-auto mb-7">

        <v-btn dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">Submit</v-btn>
      </v-col>
    </v-row> -->
    <div class="selectBox">
      <div class="inquireForm">
        <label>{{placeholder}}  <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span>
        <strong class="error" v-if="!checkValid">{{error_message}}</strong></label>
        <input :type="input_type" class="formItem" ref="input_value" v-model="input_value" :placeholder="placeholder" @keyup.enter="submit">
      </div>

      <div class="submitBtn">
        <button :id="label_name" @click="submit">次へ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: "TextFieldInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'answer_type', 'label_name'],

  created(){
    if (this.answer_type == 'email'){
      this.input_type = 'email'
    }
    if (this.answer_type == 'phone-number-no-hyphen' || this.answer_type == 'phone-number-hyphen' || this.answer_type == 'phone-number-both'){
      this.input_type = 'tel'
    }
  },

  data: () =>({
    input_value: "", 
    checkValid: true,
    input_type:'text'
  }),

  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      if (this.validateInput() == true){
        var emitValue = {user_chat_message: this.input_value, user_chat_value:this.input_value}
        this.$emit('text_input_submitted', emitValue)
        this.input_value = ''
      }else{
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
    },

    validateInput(){
      //console.log(this.input_value)
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    }

  }

}
</script>